import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@app/services/user.service';

@Injectable({
    providedIn: 'root',
})
export class CartButtonService {
    constructor(private userService: UserService, private router: Router) {}

    goToCheckout() {
        this.router.navigate(['checkout']);
    }

    hasItemsInCart(): boolean {
        const localCart = this.userService.getLocalCart();
        return localCart?.itemCount > 0;
    }

    getCartItemCount(): number {
        const localCart = this.userService.getLocalCart();
        return localCart?.itemCount || 0;
    }
}
